<template>
  <OmtLayoutContainer
    :minHeight="['initial', 'calc(100vh - 80px)']"
    :alignContent="['', 'flex-start']"
  >
    <OmtRow
      mb="16px"
      flexDirection="column"
    >
      <OmtTypography
        color="var(--colors-light-primary-gray1)"
        as="h2-bold"
        mb="16px"
      >
        Contato
      </OmtTypography>
      <OmtTypography
        color="var(--colors-light-primary-gray2)"
        as="p2"
        mr="8px"
      >
        Para atendimentos emergenciais, estamos disponíveis por telefone, WhatsApp e e-mail.
      </OmtTypography>
    </OmtRow>

    <OmtRow
      mb="16px"
      flexDirection="column"
      gap="16px"
    >
      <OmtTypography
        color="var(--colors-light-primary-gray1)"
        as="p1"
      >
        Telefone:
      </OmtTypography>
      <OmtButton
        v-for="telefone in telefones"
        :key="telefone.value"
        leftIcon="phone"
        iconSize="1x"
        fontSize="14px"
        :iconColor="'var(--colors-light-primary-navy-blue)'"
        border="1px solid var(--colors-light-primary-navy-blue)"
        size="md"
        variant="outline"
        width="100%"
        @click="handleTel(telefone)"
      >
        {{ telefone.label }}
      </OmtButton>
    </OmtRow>

    <OmtRow
      mb="16px"
      flexDirection="column"
      gap="16px"
    >
      <OmtTypography
        color="var(--colors-light-primary-gray1)"
        as="p1"
      >
        WhatsApp
      </OmtTypography>
      <OmtButton
        border="1px solid var(--colors-light-primary-navy-blue)"
        size="md"
        variant="outline"
        width="100%"
        fontSize="14px"
        leftIcon="whatsapp"
        iconSize="1x"
        :iconColor="'var(--colors-light-primary-navy-blue)'"
        @click="whatsAppSeguroViagem"
      >
        WhatsApp
      </OmtButton>
    </OmtRow>

    <CFlex flexDirection="column">
      <OmtTypography
        color="var(--colors-light-primary-gray1)"
        as="p1"
        mb="8px"
      >
        Email
      </OmtTypography>
      <a :href="`mailto:${emailContato}`">
        <OmtTypography
          color="var(--colors-light-primary-navy-blue)"
          as="h3-bold"
          text-decoration="underline"
        >
          {{ emailContato }}
        </OmtTypography>
      </a>
    </CFlex>
  </OmtLayoutContainer>
</template>

<script>
import { isMobile } from "@/utils/utils";

export default {
  name: "ContactChannel",
  data() {
    return {
      emailContato: "atendimento@omintseguroviagem.com.br",
      telefones: [
        {
          label: "+55 (11) 2132-4292",
          value: "1121324292"
        },
        {
          label: "+55 (11) 3254-2121",
          value: "1132542121"
        }
      ]
    };
  },
  computed: {
    isMobile() {
      return isMobile();
    }
  },
  mounted() {
    this.$root.$emit("hide-loading");
  },
  methods: {
    whatsAppSeguroViagem() {
      let link = " https://wa.me/551121324292";
      if (this.isMobile) {
        globalThis.window.location = `${link}?text=Ol%C3%A1`;
      } else {
        globalThis.window.open(link, "_blank", "noopener,noreferrer");
      }
    },
    handleTel(telefone) {
      globalThis.window.open(`tel: ${telefone.value}`);
    }
  }
};
</script>
